import React from "react";

interface BaseLayoutProps {
  children: React.ReactNode;
}

export const BaseLayout = ({ children }: BaseLayoutProps) => {
  return (
    <div className="flex flex-col min-h-screen bg-white-mute">
      <main>{children}</main>
    </div>
  );
};
